<template>
  <tr v-if="order" :active="value.selected" @click="value.selected = !value.selected">
    <td>
      <v-checkbox color="primary" :input-value="value.selected" primary hide-details></v-checkbox>
    </td>
    <td>{{ value.item.id }}</td>
    <td
      class="px-0"
      style="min-width: 400px; border-right: 1px solid #ddd; border-left: 1px solid #ddd;"
    >
      <template v-if="typeof value.item.productlist == 'string'">
        <div class="pa-2">
          <nl2br tag="div" :text="order.productdetail"></nl2br>
        </div>
      </template>
      <template v-else-if="typeof value.item.productlist == 'object'">
        <template v-for="(order, oindex) in value.item.productlist">
          <v-layout wrap :key="'order_' + oindex">
            <v-flex xs1>
              <div class="ma-2">
                <v-img :src="order.photourl" aspect-ratio="1" alt class="grey lighten-2">
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                    </v-layout>
                  </template>
                </v-img>
              </div>
            </v-flex>
            <v-flex xs7>
              <div class="ma-2">
                {{ order.name }} x {{ order.quantity }}
                <template v-if="order.option"
                  >({{ order.option }})</template
                >
                <div v-if="order.subproduct" class="grey--text">
                  <template v-for="(subproduct, sindex) in order.subproduct">
                    <div class="mb-1" :key="sindex">
                      {{ subproduct.name }} x {{ subproduct.quantity }}
                      <template v-if="subproduct.option"
                        >({{ subproduct.option }})</template
                      >
                    </div>
                  </template>
                </div>
              </div>
            </v-flex>
            <v-flex xs4 class="text-xs-right">
              <div class="ma-2">฿{{ order.price | decimalFormat }}</div>
            </v-flex>
          </v-layout>
          <v-divider v-if="oindex < value.item.productlist.length - 1" :key="oindex"></v-divider>
        </template>
      </template>
    </td>

    <td class="text-xs-center">{{ value.item.timestamp | DateFormat('DD/MM/YYYY') }}</td>
    <td class="text-xs-center">
      <div :style="{ height: showStatusOption ? '170px' : '' }"></div>
      <multiselect
        v-model="status"
        :options="orderStatusOptions"
        label="label"
        :allow-empty="false"
        :searchable="false"
        selectLabel
        selectedLabel
        deselect-label
        track-by="label"
        @select="onSelectOrderStatus"
        @open="showStatusOption = true"
        @close="showStatusOption = false"
      ></multiselect>
    </td>
    <td class="text-xs-center">{{ parseFloat(value.item.amount) | decimalFormat }}</td>
    <td class="text-xs-center">
      {{ (parseFloat(value.item.total) - parseFloat(value.item.shippingcharge)) | decimalFormat }}
    </td>
    <td class="text-xs-center">{{ value.item.shippingcharge | decimalFormat }}</td>
    <td class="text-xs-center">{{ value.item.totalproduct }}</td>

    <td>
      <v-btn fab outline small v-if="value.item.note" @click="$emit('viewnote')">
        <v-icon>insert_photo</v-icon>
      </v-btn>
    </td>
    <td>
      <template v-if="shippingType && shippingType == 'cod_charge'">{{
        $t('cod_charge')
      }}</template>
      <template v-else>
        <template v-if="value.item.payment == 'banktransfer' || value.item.payment == 'transfer'">{{
          $t('Bank Transfer')
        }}</template>
        <template v-else-if="order.payment == 'cod'">{{ $t('cod_charge') }}</template>
        <template v-else-if="value.item.payment == 'qrcode'"
          >Qr Code</template
        >
        <template v-else-if="value.item.payment == 'fbpay'">{{ $t('Mobile Banking') }}</template>
        <template v-else>{{ $t('Credit card') }}</template>
      </template>
    </td>
    <td>
      <template v-if="value.item.paiddate">{{
        value.item.paiddate | DateFormat('DD MMM YYYY HH:mm')
      }}</template>
      <template v-else
        >-</template
      >
    </td>
    <td>
      <template v-if="value.item.paidtime">{{ value.item.paidtime }}</template>
      <template v-else
        >-</template
      >
    </td>
    <td>{{ $t(value.item.transactionid) }}</td>
    <td style="min-width: 300px" class="text-xs-center">
      <template v-if="value.item.status == 'shipped'">
        <div class="form-control pt-2">
          <input
            type="text"
            v-model="value.item.trackingno"
            class="form-control"
            :placeholder="$t('Tracking')"
            maxlength="20"
          />
        </div>
        <div class="text-xs-center text-sm-right mb-3">
          <v-btn
            outline
            color="primary"
            @click="$emit('updateOrder', 'send')"
            :disabled="
              value.item.trackingno == null ||
                value.item.trackingno == '' ||
                value.item.trackingno.trim() == ''
            "
          >
            <i class="far fa-share-square"></i>
            &nbsp;
            {{ $t('Send') }}
          </v-btn>
        </div>
      </template>
      <template v-else-if="value.item.status == 'canceled'">
        <div class="form-control pt-2">
          <input
            type="text"
            v-model="value.item.reason"
            class="form-control"
            :placeholder="$t('Reason')"
            maxlength="300"
          />
        </div>
        <div class="text-xs-center">
          <v-btn
            outline
            color="primary"
            @click="$emit('updateOrder', 'save')"
            :disabled="
              value.item.reason == null || value.item.reason == '' || value.item.reason.trim() == ''
            "
          >
            <i class="far fa-save"></i>
            &nbsp;
            {{ $t('Save') }}
          </v-btn>
          <v-btn
            outline
            color="primary"
            @click="$emit('updateOrder', 'send')"
            :disabled="
              value.item.reason == null || value.item.reason == '' || value.item.reason.trim() == ''
            "
          >
            <i class="far fa-share-square"></i>
            &nbsp;
            {{ $t('Send') }}
          </v-btn>
        </div>
      </template>
      <template v-else>{{ value.item.trackingno }}</template>
    </td>

    <td style="min-width: 300px">
      <editable
        v-model="value.item.remark"
        :filter="'text'"
        :type="'text'"
        @edited="$emit('updateOrder', 'save')"
      ></editable>
    </td>
    <td>{{ value.item.first_name }} {{ value.item.last_name }}</td>
    <td>{{ value.item.realname }}</td>
    <td>
      {{
        computedAddress && computedAddress.length > 0 && computedAddress[7]
          ? computedAddress[7]
          : '-'
      }}
    </td>
    <td>
      {{
        computedAddress && computedAddress.length > 0 && computedAddress[3]
          ? computedAddress[3]
          : '-'
      }}
    </td>
    <td>
      {{
        computedAddress && computedAddress.length > 0 && computedAddress[4]
          ? computedAddress[4]
          : '-'
      }}
    </td>
    <td>
      {{
        computedAddress && computedAddress.length > 0 && computedAddress[5]
          ? computedAddress[5]
          : '-'
      }}
    </td>
    <td>
      {{
        computedAddress && computedAddress.length > 0 && computedAddress[6]
          ? computedAddress[6]
          : '-'
      }}
    </td>
    <td style="min-width: 300px">
      <editable
        v-model="value.item.nameaddress"
        :type="'textarea'"
        @edited="$emit('updateOrder', 'save')"
      ></editable>
    </td>

    <td class="text-xs-center">{{ value.item.tags }}</td>
    <td>{{ $t(value.item.shippingtype) }}</td>

    <td
      v-for="product in products"
      :key="product"
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item[product] > 0 }"
    >
      {{ value.item[product] }}
    </td>
    <!-- <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item.ชานมบ้านหมีหน้าร้าน > 0 }"
    >
      {{ value.item.ชานมบ้านหมีหน้าร้าน }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item.ช็อกโกแลตบ้านหมี > 0 }"
    >
      {{ value.item.ช็อกโกแลตบ้านหมี }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item.ชาไทยบ้านหมีปักษ์ใต้ > 0 }"
    >
      {{ value.item.ชาไทยบ้านหมีปักษ์ใต้ }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item.ชาพีชบ้านหมี > 0 }"
    >
      {{ value.item.ชาพีชบ้านหมี }}
    </td>

    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item.ไข่มุกบุกคาราเมลไหม้ > 0 }"
    >
      {{ value.item.ไข่มุกบุกคาราเมลไหม้ }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item.โมจิโรลนมฮอกไกโด > 0 }"
    >
      {{ value.item.โมจิโรลนมฮอกไกโด }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item.โมจิโรลช็อกโกแลต > 0 }"
    >
      {{ value.item.โมจิโรลช็อกโกแลต }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item.โมจิโรลฝอยทองบ้านหมี > 0 }"
    >
      {{ value.item.โมจิโรลฝอยทองบ้านหมี }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item.นมน้ำตาลแดงบ้านหมี > 0 }"
    >
      {{ value.item.นมน้ำตาลแดงบ้านหมี }}
    </td>

    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item.ชาดำยูซุบ้านหมี > 0 }"
    >
      {{ value.item.ชาดำยูซุบ้านหมี }}
    </td>

    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item['แป้งไข่มุกโมจิบ้านหมี D.I.Y'] > 0 }"
    >
      {{ value.item['แป้งไข่มุกโมจิบ้านหมี D.I.Y'] }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item['ถุงผ้า 9 BEARS หมี 9 ตัว'] > 0 }"
    >
      {{ value.item['ถุงผ้า 9 BEARS หมี 9 ตัว'] }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item['ถุงผ้า BROWN BEAR หมีน้ำตาล'] > 0 }"
    >
      {{ value.item['ถุงผ้า BROWN BEAR หมีน้ำตาล'] }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item['ถุงผ้า BLUE BEAR หมีน้ำเงิน'] > 0 }"
    >
      {{ value.item['ถุงผ้า BLUE BEAR หมีน้ำเงิน'] }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item['ถุงผ้า WHITE BEAR หมีขาว'] > 0 }"
    >
      {{ value.item['ถุงผ้า WHITE BEAR หมีขาว'] }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item['พุดดิ้งสุขเย็นช็อกละมุน'] > 0 }"
    >
      {{ value.item['พุดดิ้งสุขเย็นช็อกละมุน'] }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item['พุดดิ้งสุขเย็นนมละมุน'] > 0 }"
    >
      {{ value.item['พุดดิ้งสุขเย็นนมละมุน'] }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item['เหมือนฝัน เปี๊ยะโมจิไก่หยอง'] > 0 }"
    >
      {{ value.item['เหมือนฝัน เปี๊ยะโมจิไก่หยอง'] }}
    </td>
    <td
      class="text-xs-center"
      :class="{ 'primary--text font-weight-bold': value.item['เหมือนฝัน เปี๊ยะโมจิไข่เค็ม'] > 0 }"
    >
      {{ value.item['เหมือนฝัน เปี๊ยะโมจิไข่เค็ม'] }}
    </td> -->
  </tr>
</template>

<script>
// - แยกคอลัมเบอร์โทร ตำบล อำเภอ จังหวัด รหัสไปรษณีย์
// - แยกวันที่เวลา ที่ลูกค้าจ่ายเงินเป็น 2 คอลลัมน์
// - ย้ายข้อมูลสินค้าแต่ละออเดอร์

import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import Editable from '@/components/elements/Editable'
export default {
  props: ['value', 'products'],
  components: {
    Multiselect,
    Editable
  },
  data() {
    return {
      order: null,
      showStatusOption: false,
      status: {
        label: this.$t('ordered'),
        value: 'ordered'
      },
      orderStatusOptions: [
        {
          label: this.$t('pending'),
          value: 'pending'
        },
        {
          label: this.$t('ordered'),
          value: 'ordered'
        },
        {
          label: this.$t('paid'),
          value: 'paid'
        },
        {
          label: this.$t('shipped'),
          value: 'shipped'
        },
        {
          label: this.$t('cancel'),
          value: 'canceled'
        }
      ]
    }
  },
  mounted() {
    this.order = this.value.item
    var status = this.orderStatusOptions.find(el => {
      return el.value == this.value.item.status
    })
    // console.log(status)
    if (status) {
      this.status = status
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    tags: function() {
      var tags = []
      if (this.value.tags && this.value.tags.trim() != '') {
        tags = this.value.tags.split(',')
      }
      return tags
    },
    shippingType: function() {
      var shippingType = ''
      try {
        var jsondata = JSON.parse(this.order.shippingtype)

        shippingType = jsondata.type ? jsondata.type : ''
      } catch (error) {
        shippingType = this.order.shippingtype
      }
      return shippingType
    },
    computedAddress() {
      return this.order.nameaddress ? this.order.nameaddress.split(' , ') : null
    }
  },
  methods: {
    onSelectOrderStatus: function(status) {
      // var order = this.order
      // order.status = status.value
      // this.$emit('input', order)
      this.$emit('onChangeStatus', status)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/BearhouseOrderItem.vue